<template>
  <v-container fluid grid-list-md>
    <!-- PIES -->
    <v-layout row wrap>
      <v-flex xs4>
        <CorePieChart
          :series="series1"
          :key="`pie1-${componentKey}`"
          format="currency"
          v-model="series1"
          v-if="series1"
        >
          <template slot="header">
            <h3 class="text-left title font-weight-bold">Spent ($)</h3>
            <h3 class="text-left subheading font-weight-regular">
              Total Spent: $ {{ totalSpent | numFloat }}
            </h3>
          </template>
        </CorePieChart>
      </v-flex>
      <v-flex xs4>
        <CorePieChart
          :series="series2"
          :key="`pie2-${componentKey}`"
          format="float"
          v-model="series2"
          v-if="series2"
        >
          <template slot="header">
            <h3 class="text-left title font-weight-bold">MWH</h3>
            <h3 class="text-left subheading font-weight-regular">
              Total MWH: {{ totalMwh | numFloat }}
            </h3>
          </template>
        </CorePieChart>
      </v-flex>
      <v-flex xs4>
        <CorePieChart
          :series="series3"
          :key="`pie3-${componentKey}`"
          format="currency"
          v-model="series3"
          v-if="series3"
        >
          <template slot="header">
            <h3 class="text-left title font-weight-bold">$/MWH</h3>
            <h3 class="text-left subheading font-weight-regular">
              Total $/MWH: {{ totalCostMwh | numFloat }}
            </h3>
          </template>
        </CorePieChart>
      </v-flex>
    </v-layout>

    <!-- TABLE -->
    <v-layout row wrap v-if="json" class="mb-5">
      <v-flex xs3>
        <SimulateStat baseColor="#409ed4" class="mb-2">
          <template slot="stat_data">
            <div class="text-right">
              <div class="text-right body-2">
                Total Spent
              </div>
              <!-- <div class="text-right subheading">{{ item.title }}</div> -->
              <div class="text-right display-1 font-weight-bold compress">
                ${{ totalSpent | numFloat }}
              </div>
              <span class="text-right body-2"></span>
            </div>
          </template>
        </SimulateStat>

        <SimulateStat baseColor="#409ed4" class="mb-2">
          <template slot="stat_data">
            <div class="text-right">
              <div class="text-right body-2">
                Total MWH
              </div>
              <!-- <div class="text-right subheading">{{ item.title }}</div> -->
              <div class="text-right display-1 font-weight-bold compress">
                {{ totalMwh | numFloat }}
              </div>
              <span class="text-right body-2"></span>
            </div>
          </template>
        </SimulateStat>

        <SimulateStat baseColor="#409ed4" class="mb-2">
          <template slot="stat_data">
            <div class="text-right">
              <div class="text-right body-2">
                Total $/MWH
              </div>
              <!-- <div class="text-right subheading">{{ item.title }}</div> -->
              <div class="text-right display-1 font-weight-bold compress">
                ${{ totalCostMwh | numFloat }}
              </div>
              <span class="text-right body-2"></span>
            </div>
          </template>
        </SimulateStat>
      </v-flex>
      <v-flex xs9>
        <v-card class="hidden-sm-and-down mb-2 mt-1">
          <v-card-title>
            <v-layout row>
              <!-- title ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
              <v-flex xs9 class="headline text-left"
                >Breakdown By Source
              </v-flex>
              <!-- search ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
              <v-flex xs3 text-right>
                <v-text-field
                  v-model="search"
                  prepend-inner-icon="search"
                  placeholder="search"
                  clearable
                  style="margin-top:-20px;margin-bottom:5px;"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <!-- table ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <v-data-table
              dense
              :headers="headers"
              :items="json.sources"
              :search="search"
              :pagination.sync="pagination"
              item-key="name"
              class="standard-table"
              must-sort
              expand
            >
              <template slot="headers" slot-scope="props">
                <tr>
                  <th
                    v-for="header in props.headers"
                    :key="header.value"
                    :class="[
                      'column text-right sortable',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : ''
                    ]"
                    @click="$_tableMixin_changeSort(header.value, pagination)"
                  >
                    <v-icon
                      v-if="header.sortable"
                      class="px-1"
                      color="red darken-2"
                      >arrow_drop_up</v-icon
                    >
                    <span class="font-weight-bold" v-html="header.text"></span>
                  </th>
                </tr>
              </template>

              <!-- data ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
              <template slot="items" slot-scope="props">
                <tr
                  v-bind:class="{
                    shadow:
                      ((pagination.page - 1) * pagination.rowsPerPage +
                        props.index) %
                        2 !=
                      0
                  }"
                >
                  <td class="text-right body-1">
                    {{ props.item.name }}
                  </td>
                  <td class="text-right body-1">
                    ${{ props.item.spent | numFloat }}
                  </td>
                  <td class="text-right clr-load">
                    {{ props.item.mwh | numFloat }}
                  </td>
                  <td class="text-right clr-target">
                    ${{ props.item.cost_mwh | numFloat }}
                  </td>
                  <td class="text-right clr-load">
                    {{ props.item.btu | numFloat }}
                  </td>
                  <td class="text-right clr-target">
                    ${{ props.item.cost_btu | numFloat }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import dailySpentRawData from '@/json/daily_spend_1.json'
import SimulateStat from './SimulateStat'
export default {
  name: 'Spend',
  components: {
    SimulateStat
  },
  data() {
    return {
      json: false,
      options: false,
      series1: false,
      series2: false,
      series3: false,
      componentKey: 0,

      totalSpent: 0.0,
      totalMwh: 0.0,
      totalCostMwh: 0.0,

      search: '',
      pagination: {
        rowsPerPage: 10,
        sortBy: 'ending'
      },
      headers: [
        {
          text: 'NAME',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: 'SPENT',
          align: 'left',
          sortable: true,
          value: 'spent'
        },
        {
          text: 'MWH',
          align: 'left',
          sortable: true,
          value: 'mwh'
        },
        {
          text: '$/MWH',
          align: 'left',
          sortable: true,
          value: 'cost_mwh'
        },
        {
          text: 'MMBTU',
          align: 'left',
          sortable: true,
          value: 'btu'
        },
        {
          text: '$/MMBTU',
          align: 'left',
          sortable: true,
          value: 'cost_btu'
        }
      ]
    }
  },
  mounted() {
    this.fetch()
    this.componentKey++
  },
  filters: {
    numInt(value) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        currency: 'USD',
        minimumFractionDigits: 0
      })
      return formatter.format(value)
    },
    numFloat(value) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        currency: 'USD',
        minimumFractionDigits: 2
      })
      return formatter.format(value)
    }
  },
  methods: {
    formatInt(value) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        currency: 'USD',
        minimumFractionDigits: 0
      })
      return formatter.format(value)
    },
    formatFloat(value) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        currency: 'USD',
        minimumFractionDigits: 2
      })
      return formatter.format(value)
    },
    fetch() {
      this.json = []
      this.json = dailySpentRawData
      this.build()
    },
    build() {
      this.pie()
      this.componentKey += 1
    },
    pie() {
      let spent = []
      let mwh = []
      let cost_mwh = []
      let pie1 = []
      let pie2 = []
      let pie3 = []
      let total_spent = 0.0
      let total_mwh = 0.0

      this.series1 = []
      this.series2 = []

      for (var z = 0; z < this.json.sources.length; z++) {
        let src = this.json.sources[z]

        spent[z] = parseFloat(src.spent)
        mwh[z] = parseFloat(src.mwh)
        cost_mwh[z] = parseFloat(src.cost_mwh)
        total_spent += parseFloat(spent[z])
        total_mwh += parseFloat(mwh[z])

        let selected = z === 0 ? true : false

        pie1.push({
          name: src.name,
          y: spent[z],
          sliced: true,
          selected: selected
        })
        pie2.push({
          name: src.name,
          y: mwh[z],
          sliced: true,
          selected: selected
        })
        pie3.push({
          name: src.name,
          y: cost_mwh[z],
          sliced: true,
          selected: selected
        })
      }
      this.totalSpent = total_spent
      this.totalMwh = total_mwh
      this.totalCostMwh = parseFloat(this.totalSpent / this.totalMwh)

      this.series1 = [
        {
          name: 'Spent',
          colorByPoint: true,
          allowPointSelect: true,
          data: pie1
        }
      ]

      this.series2 = [
        {
          name: 'MWH',
          colorByPoint: true,
          allowPointSelect: true,
          data: pie2
        }
      ]

      this.series3 = [
        {
          name: '$/MWH',
          colorByPoint: true,
          allowPointSelect: true,
          data: pie3
        }
      ]
    }
  }
}
</script>
